import { render } from "./GuidancePlanDetail.vue?vue&type=template&id=071f6ec0&scoped=true&ts=true"
import script from "./GuidancePlanDetail.vue?vue&type=script&lang=ts"
export * from "./GuidancePlanDetail.vue?vue&type=script&lang=ts"

import "./GuidancePlanDetail.vue?vue&type=style&index=0&id=071f6ec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071f6ec0"]])

export default __exports__